<!--
* Copyright (c) 2024, ResMed Inc. All rights reserved.
-->
<div class="main-div">
  <div class="search-bars">
    <ul>
      <!-- Dropdown box for survey id -->
      <li class="site-nav__item">
        <select
          id="survey-dropdown-nav"
          class="site-nav__dropdown"
          (change)="save($event)"
          >
          <option value="airview-web">Airview Web</option>
          <option value="">None</option>
          <option value="default">Default</option>
          <option value="airview-pdf">Airview Pdf</option>
          <option value="compliance-coach">Compliance Coach</option>
          <option value="werewolf">Werewolf</option>
        </select>
      </li>

      <!-- Checkbox to enable Declines -->
      <li class="site-nav__item">
        <div class="checkbox-container">
          <label class="checkbox-label" for="enable-decline">
            Declines
            <input
              type="checkbox"
              [(ngModel)]="declineEnabled"
              id="enable-decline"
              class="checkbox-input"
              />
          </label>
        </div>
      </li>

      <!-- Textbox for search -->
      <li class="site-nav__item">
        <input
          type="text"
          id="source-id"
          class="site-nav__textbox"
          placeholder="Enter Source ID"
          />
      </li>

      <!-- Button for executing search -->
      <li class="site-nav__item">
        <button id="searchBtn" class="site-nav__button" (click)="search()">
          Search
        </button>
      </li>
    </ul>
  </div>
  <main>
    <!-- Alert messages -->
    <div id="query-err" class="alert alert-danger fade" role="alert">
      {{ errorMsg }}
    </div>

    <!-- Modals -->

    <!-- Trigger Survey Modal -->
    <app-trigger-survey></app-trigger-survey>

    <!-- HME Consent Modal -->
    <app-hme-consent></app-hme-consent>

    <!-- Search Results Table -->
    <div id="results" class="hidden displayed">
      <table id="resultTable" class="tables">
        <th colspan="2" class="device-cell">
          <strong>Care Check-In</strong>
          <button
            id="btnExpand"
            class="btn btn-secondary"
            (click)="toggleAccordion()"
            >
            Expand All
          </button>
        </th>
        <tbody>
          <!-- Template to produce results from json blob returned from search query -->
          <ng-template #results>
            @for (
              item of surveyResponses.groupedQuestions; track
              item; let qstCount = $index) {
              <tr>
                <td colspan="2" class="date-cell">
                  <div
                    class="accordion accordion-flush"
                    [attr.id]="'accordion' + qstCount"
                    >
                    <div
                      class="accordion-item"
                      [attr.id]="'testing-' + qstCount"
                      >
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          [attr.data-bs-target]="
                            '#accordion' + qstCount + '-collapse'
                          "
                          aria-expanded="true"
                          [attr.aria-controls]="
                            'accordion' + qstCount + '-collapse'
                          "
                          style="font-weight: bold"
                          >
                          {{ item.date }} - Day Offset: {{ item.dayOffset }}
                        </button>
                      </h2>
                      <div
                        class="accordion-collapse collapse show"
                        [attr.id]="'accordion' + qstCount + '-collapse'"
                        [attr.data-bs-parent]="'#accordion' + qstCount"
                        >
                        <div class="accordion-body" id="question-answer">
                          @for (
                            innerItem of surveyResponses.groupedQuestions[
                            qstCount
                            ].questions; track
                            innerItem; let innerQstCount = $index) {
                            <div
                              class="qst-block"
                              >
                              <div class="display-ctn">
                                <div style="font-weight: bold" class="qst-value">
                                  {{ innerItem.questionTranslationValue }}
                                </div>
                                <div class="answer-feedback">
                                  @if (innerItem?.answers) {
                                    @if (
                                      innerItem.answers[0]?.categories) {
                                      {{
                                      innerItem.answers[0]
                                      .answerTranslationValue
                                      }}
                                      @if (
                                        innerItem.answers[0].categories[0] ==
                                        'negative-feedback') {
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          class="c-svg c-svg--thumb-down-24 svg-feedback"
                                          style="fill: #b92025"
                                          >
                                          <path
                                            d="M15 3h-9c-0.83 0-1.54 0.5-1.84 1.22l-3.020 7.050c-0.090 0.23-0.14 0.47-0.14 0.73v2c0 1.1 0.9 2 2 2h6.31l-0.95 4.57-0.030 0.32c0 0.41 0.17 0.79 0.44 1.060l1.060 1.050 6.59-6.59c0.36-0.36 0.58-0.86 0.58-1.41v-10c0-1.1-0.9-2-2-2zM19 3v12h4v-12h-4z"
                                          ></path>
                                        </svg>
                                      } @else {
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          class="c-svg c-svg--thumb-up-24 svg-feedback"
                                          style="fill: #1788c3"
                                          >
                                          <path
                                            d="M1 21h4v-12h-4v12zM23 10c0-1.1-0.9-2-2-2h-6.31l0.95-4.57 0.030-0.32c0-0.41-0.17-0.79-0.44-1.060l-1.060-1.050-6.58 6.59c-0.37 0.36-0.59 0.86-0.59 1.41v10c0 1.1 0.9 2 2 2h9c0.83 0 1.54-0.5 1.84-1.22l3.020-7.050c0.090-0.23 0.14-0.47 0.14-0.73v-2z"
                                          ></path>
                                        </svg>
                                      }
                                    } @else {
                                      {{
                                      innerItem.answers[0]
                                      .answerTranslationValue
                                      }}
                                    }
                                  } @else {
                                    <span class="declineBlock"> Declined: </span>
                                    {{ innerItem.declineType }}
                                  }
                                </div>
                                <div class="info-popup">
                                  <button
                                    [ngbPopover]="popoverContent"
                                    class="popover-btn"
                                    >
                                    &#9432;
                                  </button>
                                  <ng-template #popoverContent>
                                    <div class="popover-content">
                                      <div>
                                        <strong>Survey ID: </strong>
                                        <span
                                        (click)="
                                          copyToClipboard(innerItem.surveyId)
                                        "
                                        style="
                                          cursor: pointer;
                                          text-decoration: underline;
                                        "
                                          >
                                          {{ innerItem.surveyId }}
                                        </span>
                                      </div>
                                      <div>
                                        <strong>Question ID: </strong>
                                        <span
                                        (click)="
                                          copyToClipboard(innerItem.questionId)
                                        "
                                        style="
                                          cursor: pointer;
                                          text-decoration: underline;
                                        "
                                          >
                                          {{ innerItem.questionId }}
                                        </span>
                                      </div>
                                      @if (innerItem?.answers) {
                                        <div>
                                          <strong>Answer: </strong>
                                          <span
                                        (click)="
                                          copyToClipboard(
                                            innerItem.answers[0]
                                              .answerTranslationValue
                                          )
                                        "
                                        style="
                                          cursor: pointer;
                                          text-decoration: underline;
                                        "
                                            >
                                            {{
                                            innerItem.answers[0]
                                            .answerTranslationValue
                                            }}
                                          </span>
                                        </div>
                                      }
                                      <div>
                                        <strong>Day Offset: </strong>
                                        <span>
                                          {{ innerItem.dayOffset }}
                                        </span>
                                      </div>
                                      <div>
                                        <strong>Date Time: </strong>
                                        <span>
                                          {{
                                          innerFormatDate(innerItem.dateTime)
                                          }}
                                        </span>
                                      </div>
                                      @if (innerItem.source?.origin) {
                                        <div>
                                          <strong>Origin: </strong>
                                          <span>
                                            {{ innerItem.source.origin }}
                                          </span>
                                        </div>
                                      }
                                      @if (innerItem.source?.deviceSerial) {
                                        <div>
                                          <strong>Device Serial: </strong>
                                          <span
                                        (click)="
                                          copyToClipboard(
                                            innerItem.source.deviceSerial
                                          )
                                        "
                                        style="
                                          cursor: pointer;
                                          text-decoration: underline;
                                        "
                                            >
                                            {{ innerItem.source.deviceSerial }}
                                          </span>
                                        </div>
                                      }
                                      @if (innerItem.source?.patientId) {
                                        <div>
                                          <strong>Patient ID: </strong>
                                          <span
                                        (click)="
                                          copyToClipboard(
                                            innerItem.source.patientId
                                          )
                                        "
                                        style="
                                          cursor: pointer;
                                          text-decoration: underline;
                                        "
                                            >
                                            {{ innerItem.source.patientId }}
                                          </span>
                                        </div>
                                      }
                                      @if (innerItem.source?.patientEcn) {
                                        <div>
                                          <strong>Patient ECN: </strong>
                                          <span
                                        (click)="
                                          copyToClipboard(
                                            innerItem.source.patientEcn
                                          )
                                        "
                                        style="
                                          cursor: pointer;
                                          text-decoration: underline;
                                        "
                                            >
                                            {{ innerItem.source.patientEcn }}
                                          </span>
                                        </div>
                                      }
                                    </div>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </ng-template>
          <ng-container *ngTemplateOutlet="results"></ng-container>
        </tbody>
      </table>
    </div>
  </main>
</div>
